import { useTranslation } from "next-i18next";

import { useSearchContext } from "@/features/search/context/SearchContext";

/** Empty state with a reset action when filters are applied. */
export const ResultsEmpty = () => {
  const { t } = useTranslation();
  const { navigation } = useSearchContext();

  return (
    <div className="flex flex-col items-center space-y-4 py-16 text-center">
      <p className="font-title text-lg font-semibold text-black">
        {t("common:common-no-results")}
      </p>
      <p className="max-w-sm font-body text-sm text-grey-500">
        {t("listing:listing-no-search-results-subheading")}
      </p>
      <button
        type="button"
        onClick={() => navigation.reset()}
        className="font-body text-sm font-semibold text-brand-500 hover:underline"
      >
        {t("listing:filter-clear-all")}
      </button>
    </div>
  );
};
